import React from "react"

export default ({ src }) => <img loading="lazy" src={require(src)} />
